import {atomWithStorage} from "jotai/utils";
import {jsonStorage} from "@/utils/jsonStorage";
import {useAtom} from "jotai";

export const localeAtom = atomWithStorage<string>("locale", "en", jsonStorage, {
  getOnInit: true,
});

export const useLocale = () => useAtom(localeAtom);
